import React, { useState, createContext } from 'react';
import { message } from 'antd';
import axios from 'axios'; // Assumed API service similar to api_srv
import { api_srv } from '../services';


const ProductContext = createContext();
const ProductContextProvider = ({ children }) => {
  // STATES
  const [current, setCurrent] = useState(0);

  const [productData, setProductData] = useState({
    subclass: '000',
    covertype_code: '999',
    product_ref: '999',
    product_name: '99',
    minimum_premium: '1000',
    policy_term: 'rwqor',
    rate_code: 'rwqor',
    commission_code: 'rqrq',
    workflow_code: 'p4p243',
    system_policy_delivery_ref: '2421',
    policy_no_config_system_ref: '2142',
    system_claim_config_ref: '1421',
    description: '3141',
    preferred_currency: ['usd', 'ksh'],
    additional_data: {
      embedable: 'true',
      auto_limit: '200',
      premium_notification_frequency: '5',
      business_type: 'bux',
      ipf_consideration: 'ifqwr',
      ipf_entity: 'rqwrw',
      client_trxn_charges: 'rqreq',
      kyc_checks: ["ii", 'ii'],
      charges: [{}],
    },
    product_code: 'rqrq',
    product_id: 'rqrqrq21-4932',
  });

  const [image, setImage] = useState({
    logo: [],
    loading: false,
    url: '',
    placeholder: '',
  });

  const [subClasses, setSubClasses] = useState([]);
  const [coverTypes, setCoverTypes] = useState([]);
  const [rates, setRates] = useState([]);
  const [commissions, setCommissions] = useState([]);
  const [workflows, setWorkflows] = useState([]);
  const [policyNoConfigs, setPolicyNoConfigs] = useState([]);
  const [policyDeliveries, setPolicyDeliveries] = useState([]);
  const [claimConfigs, setClaimConfigs] = useState([]);
  const [charges, setCharges] = useState([]);
  const [productCharges, setProductCharges] = useState([]);
  const [kycChecks, setKycChecks] = useState([]);
  const [generalRequirements, setGeneralRequirements] = useState([]);
  const [claimSummary, setClaimSummary] = useState([]);
  const [selectedClaimTypes, setSelectedClaimTypes] = useState([]);

  // METHODS/FUNCTIONS
  const next = () => {
    const current_step = current + 1;
    console.log('next', current_step);
    setCurrent(current_step);
  };

  const prev = () => {
    const current_step = current - 1;
    console.log('prev', current_step);
    setCurrent(current_step);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must be smaller than 2MB!');
      return false;
    }
    return true;
  };

  const handleImageChange = (info) => {
    let fileList = [...info.fileList].slice(-1); // Limit to one file
    fileList = fileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });
    setImage({ ...image, logo: fileList });
  };

  const uploadProductLogo = async (options) => {
    const { onSuccess, onError, file } = options;
    try {
      const formData = new FormData();
      formData.append('logo', file);
      formData.append('product_id', productData.product_id);

      const res = await axios.post('/v1/api/upload/v1/underwritter/product_logo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log('server res: ', res);
      onSuccess('Ok');
      message.success(`${file.name} uploaded successfully.`);
      setImage({ ...image, url: URL.createObjectURL(file), placeholder: file.name, loading: false });
    } catch (err) {
      onError({ err });
      message.error(`${file.name} upload failed.`);
      setImage({ ...image, logo: [], loading: false });
    }
  };

  // const fetchSubClasses = async () => {
  //   try {
  //    // const res = await axios.get('/v1/api/subclass/list_summary');
  //     const res = await (await api_srv).fetchIntermediaryProfile();
  //     setSubClasses(res.data.result.underwritter_subclasses || []);
  //   } catch (err) {
  //     console.error('Error fetching subclasses:', err);
  //     message.error('Failed to fetch subclasses.');
  //   }
  // };

  // const fetchUnderwriterRates = async () => {
  //   try {
  //     //const res = await axios.get('/v1/api/rate/list');
  //     const res = await (await api_srv).fetchIntermediaryProfile();
  //     setRates(res.data.result.rates || []);
  //   } catch (err) {
  //     console.error('Error fetching rates:', err);
  //     message.error('Failed to fetch rates.');
  //   }
  // };

  // const fetchCommissions = async () => {
  //   try {
  //   //   const res = await axios.get('/v1/api/commission/list');
  //   const res = await (await api_srv).fetchIntermediaryProfile();
  //     setCommissions(res.data.result.commission_configs || []);
  //   } catch (err) {
  //     console.error('Error fetching commissions:', err);
  //     message.error('Failed to fetch commissions.');
  //   }
  // };

  // const fetchProductCharges = async () => {
  //   try {
  //   //   const res = await axios.get('/v1/api/product_charge/list');
  //    const res = await (await api_srv).fetchIntermediaryProfile();   
  //     setCharges(res.data.result.charges || []);
  //   } catch (err) {
  //     console.error('Error fetching charges:', err);
  //     message.error('Failed to fetch charges.');
  //   }
  // };

  // const fetchWorkflows = async () => {
  //   try {
  //   //   const res = await axios.get('/v1/api/workflow/list');
  //    const res = await (await api_srv).fetchIntermediaryProfile();
  //     setWorkflows(res.data.result.workflows || []);
  //   } catch (err) {
  //     console.error('Error fetching workflows:', err);
  //     message.error('Failed to fetch workflows.');
  //   }
  // };

  // const fetchPolicyNoConfigs = async () => {
  //   try {
  //   //   const res = await axios.get('/v1/api/policy_no_config/list');
  //    const res = await (await api_srv).get_intermediary_type();
  //     setPolicyNoConfigs(res.data.result.policy_no_configs || []);
  //   } catch (err) {
  //     console.error('Error fetching policy no configs:', err);
  //     message.error('Failed to fetch policy no configs.');
  //   }
  // };

  // const fetchPolicyDeliveries = async () => {
  //   try {
  //   //   const res = await axios.get('/v1/api/policy_delivery/list');
  //    const res = await (await api_srv).get_intermediary_type();
  //     setPolicyDeliveries(res.data.result.policy_deliveries || []);
  //   } catch (err) {
  //     console.error('Error fetching policy deliveries:', err);
  //     message.error('Failed to fetch policy deliveries.');
  //   }
  // };

  // const fetchClaimConfigs = async () => {
  //   try {
  //   //  const res = await axios.get('/v1/api/claim_config/list');
  //     const res = await (await api_srv).get_intermediary_type();
  //     setClaimConfigs(res.data.result.claim_configs || []);
  //   } catch (err) {
  //     console.error('Error fetching claim configs:', err);
  //     message.error('Failed to fetch claim configs.');
  //   }
  // };

  // const fetchSubclassGeneralRequirement = async (sub_class_code) => {
  //   try {
  //   //   const res = await axios.get('/v1/api/sub_class/product_requirement', {
  //   //     params: { sub_class_code },
  //   //   });
  //     const res = await (await api_srv).get_intermediary_type();
  //     setGeneralRequirements(res.data.result.product_requirement || []);
  //   } catch (err) {
  //     console.error('Error fetching general requirements:', err);
  //     message.error('Failed to fetch general requirements.');
  //   }
  // };

  // const fetchSubclassClaimSummary = async (underwritter_class_code) => {
  //   try {
  //   //   const res = await axios.get('/v1/api/subclass/claim_summary', {
  //   //     params: { underwritter_class_code },
  //   //   });
  //     const res = await (await api_srv).get_intermediary_type();
  //     setClaimSummary(res.data.result.subclass_claim_summary || []);
  //   } catch (err) {
  //     console.error('Error fetching claim summary:', err);
  //     message.error('Failed to fetch claim summary.');
  //   }
  // };

  // const createProduct = async (data) => {
  //   try {
  //     await axios.post('/v1/api/product/add', data);
  //     message.success('Product created successfully.');
  //   } catch (err) {
  //     console.error('Error creating product:', err);
  //     message.error('Failed to create product.');
  //     throw err;
  //   }
  // };

  // const addProductDetails = async (data) => {
  //   try {
  //     await axios.post('/v1/api/product/additional_details', data);
  //     message.success('Product details added successfully.');
  //   } catch (err) {
  //     console.error('Error adding product details:', err);
  //     message.error('Failed to add product details.');
  //     throw err;
  //   }
  // };

  // const saveProductClaimConfig = async (product_code, claim_config) => {
  //   try {
  //     await axios.post('/v1/api/product_setup/claim_type', {
  //       product_code,
  //       claim_config,
  //     });
  //     message.success('Claim config saved successfully.');
  //   } catch (err) {
  //     console.error('Error saving claim config:', err);
  //     message.error('Failed to save claim config.');
  //     throw err;
  //   }
  // };

  // const saveProductRequirements = async (product_id, requirements) => {
  //   try {
  //     await axios.post('/v1/api/product/add_requirements', {
  //       product_id,
  //       requirements,
  //     });
  //     message.success('Product requirements saved successfully.');
  //   } catch (err) {
  //     console.error('Error saving requirements:', err);
  //     message.error('Failed to save product requirements.');
  //     throw err;
  //   }
  // };

  // const fetchProductDetails = async (product_code) => {
  //   try {
  //     const res = await axios.get('/v1/api/product/details_by_code', {
  //       params: { product_code },
  //     });
  //     setProductData((prev) => ({
  //       ...prev,
  //       product_code,
  //       product_id: res.data.result.product_details.product_id,
  //     }));
  //     message.success('Product details fetched successfully.');
  //     return res.data.result.product_details;
  //   } catch (err) {
  //     console.error('Error fetching product details:', err);
  //     message.error('Failed to fetch product details.');
  //     throw err;
  //   }
  // };

  return (
    <ProductContext.Provider
      value={{
        current,
        setCurrent,
        productData,
        setProductData,
        next,
        prev,
        image,
        setImage,
        subClasses,
        setSubClasses,
        coverTypes,
        setCoverTypes,
        rates,
        commissions,
        workflows,
        policyNoConfigs,
        policyDeliveries,
        claimConfigs,
        charges,
        setCharges,
        productCharges,
        setProductCharges,
        kycChecks,
        setKycChecks,
        generalRequirements,
        claimSummary,
        selectedClaimTypes,
        setSelectedClaimTypes,
        beforeUpload,
        handleImageChange,
        uploadProductLogo,
        // fetchUnderwriterRates,
        // fetchSubClasses,
        // fetchCommissions,
        // fetchProductCharges,
        // fetchWorkflows,
        // fetchPolicyNoConfigs,
        // fetchPolicyDeliveries,
        // fetchClaimConfigs,
        // fetchSubclassGeneralRequirement,
        // fetchSubclassClaimSummary,
        // createProduct,
        // addProductDetails,
        // saveProductClaimConfig,
        // saveProductRequirements,
        // fetchProductDetails,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

const ProductConsumer = ProductContext.Consumer;
export { ProductContextProvider, ProductConsumer, ProductContext };
